import Vue from 'vue'
import App from './App.vue'
import router from './router'

import dotenv from 'dotenv'
dotenv.config()

var domain = process.env.VUE_APP_AUTH0_DOMAIN;
var clientId = process.env.VUE_APP_AUTH0_CLIENTID;
var audience = process.env.VUE_APP_AUTH0_AUDIENCE;
var scope = process.env.VUE_APP_AUTH0_SCOPE;
console.log("DOMAIN: " + domain);
// Import the plugin here
import { Auth0Plugin } from "./auth";

const PortalApi = require("@brightoncromwell/portal-api");
PortalApi.ApiClient.instance.basePath = process.env.VUE_APP_API_BASEPATH;
PortalApi.ApiClient.instance.enableCookies = true;
console.log("API enableCookies = " + PortalApi.ApiClient.instance.enableCookies);

console.log("process.env.VUE_APP_Datadog_RUM__applicationId = "+ process.env.VUE_APP_Datadog_RUM__applicationId);
console.log("process.env.VUE_APP_Datadog_RUM__clientToken = "+ process.env.VUE_APP_Datadog_RUM__clientToken);
console.log("process.env.VUE_APP_Datadog__env = "+ process.env.VUE_APP_Datadog__env);
console.log("process.env.VUE_APP_Datadog_Logs__clientToken = "+ process.env.VUE_APP_Datadog_Logs__clientToken);

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

Vue.config.productionTip = false

export const eventBus = new Vue();

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

// Install the authentication plugin here (oauth)
Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  scope,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  }
});

new Vue({
  router,
  // store,
  render: h => h(App)
}).$mount('#app')

import { datadogLogs } from '@datadog/browser-logs';


// PROVIDES LOGGING OF USER ACTIVITY AT Datadog.com
datadogLogs.init({  
  clientToken: process.env.VUE_APP_Datadog_Logs__clientToken,    
  env: process.env.VUE_APP_Datadog__env,
  site: 'datadoghq.com',
  forwardErrorsToLogs: true,
  sampleRate: 100,
  useSecureSessionCookie: true
});


import { datadogRum } from '@datadog/browser-rum';  // "RUM" = "Real User Management"

datadogRum.init({
  applicationId: process.env.VUE_APP_Datadog_RUM__applicationId, 
  clientToken:   process.env.VUE_APP_Datadog_RUM__clientToken, 
  env: process.env.VUE_APP_Datadog__env,
  site: 'datadoghq.com',
  service: 'my-web-application',
  version: '1.0.0',
  sampleRate: 100,
  trackInteractions: true
});
